export const JUDGE_INTERVEENING = 1;
export const JUDGE_FIXED = 2;